export default {
  lbl_address_ticket: 'Dirección de la Solicitud',
  lbl_map_hint: 'Marque la ubicación de su solicitud',
  address_no_found: 'Dirección no encontrada.',
  error_map_load: 'Error al cargar el mapa',
  select: 'Seleccionar',
  cancel: 'Cancelar'
}
